import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'

export class DadosOperadoras {
    static utilizaNumeroEstabelecimento(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'greencard':
            case 'pagseguro':
            case 'paypal':
            case 'senff':
            case 'stelo':
            case 'sumup':
            case 'bigcard':
            case 'acqio':
            case 'comprocard':
            case 'globalpayments':
                return false
        }

        return true
    }

    static numeroEstabelecimentoMaxlength(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'sicredi':
                return 14
            case 'santandergetnet':
                return 10
            case 'bndes':
                return 14
            case 'saudeservice':
                return 14
            case 'brasilcard':
                return 11
            case 'banescard':
                return 20
            case 'cabal':
                return 14
        }

        return 15
    }

    static numeroEstabelecimentoDescricao(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'banese':
            case 'losango':
                return 'código da loja'
            case 'banescard':
                return 'código do estabelecimento'
            case 'brasilcard':
                return 'CPF'
            case 'cabal':
                return 'estabelecimento'
            case 'sicredi':
                return 'CNPJ'
            case 'bndes':
                return 'CNPJ'
        }

        return 'n° do estabelecimento'
    }

    static numeroEstabelecimentExplicacao(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'sipag':
                return 'cód. do cliente junto a SIPAG ou CNPJ'    
        }

        return this.numeroEstabelecimentoDescricao(operadora)
    }
    
    static utilizaCodigoAcesso(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'goodcard':
            case 'ticketcar':
                return true
        }

        return false
    }

    static utilizaToken(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'pagseguro':
                return true
            case 'sumup':
                return true
        }

        return false
    }

    static usuarioEmail(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'paypal':
            case 'redecard':
            case 'vrbeneficios':
            case 'pagseguro':
            case 'sumup':
            case 'acqio':
            case 'stone':
            case 'globalpayments':
                return true
        }

        return false
    }

    static usuarioNumerico(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'greencard':
            case 'alelo':
            case 'bigcard':
            case 'cabal':
            case 'sicredi':
                return true
        }

        return false
    }

    static usuarioDescricao(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'vero':
                return 'CPF'
            case 'pagseguro':
                return 'E-mail'
            case 'bigcard':
                return 'Código'
            case 'brasilcard':
                return 'PDV'
            case 'acqio':
                return 'E-mail'
            case 'cabal':
                return 'CPF'
            case 'stone':
                return 'E-mail'
            case 'redecard':
                return 'E-mail'
            case 'globalpayments':
                return 'E-mail'
            case 'cielo':
                return 'E-mail, CPF ou Usuário'
            case 'comprocard':
                return 'Código Lojista'
            case 'santandergetnet':
                return 'CPF ou E-Mail'
            case 'bndes':
                return 'Login ou CPF'
        }

        return 'Usuário'
    }

    static usuarioMaxlength(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'greencard':
                return 14
            case 'losango':
                return 8
            case 'vero':
                return 11
            case 'alelo':
                return 11
            case 'bndes':
                return 30
            case 'saudeservice':
                return 100
            case 'banescard':
                return 20
            case 'policard':
                return 50
            case 'bigcard':
                return 16
            case 'acqio':
                return 128
            case 'cabal':
                return 11
            case 'sicredi':
                return 14
            case 'globalpayments':
                return 256
            default:
                return 100
        }
    }

    static senhaNumerica(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'senff':
                return true
        }

        return false
    }

    static senhaMaxlength(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            case 'losango':
            case 'senff':
                return 8
            case 'vero':
                return 10
            case 'banescard':
                return 20
            case 'policard':
                return 250
            case 'bigcard':
                return 4
            case 'acqio':
                return 128
            case 'cabal':
                return 10
            case 'sicredi':
                return 20
            default:
                return 100
        }
    }

    static codigoAcessoMaxlength(operadora: OperadoraDeMaquina) {
        switch (obterCodenameLowerCase(operadora)) {
            default:
                return 10
        }
    }
}

function obterCodenameLowerCase(operadora: OperadoraDeMaquina) {
    return operadora && operadora.codename && operadora.codename.toLowerCase()
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/estabelecimento-modal/dados-operadoras.ts